"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStandardDeviation = exports.getPercentage = exports.getFrequency = exports.getPL = exports.getSRP = exports.getRTP = exports.DEFAULT_PERCENTAGE = exports.DEFAULT_FREQUENCY = exports.DEFAULT_SRP = exports.DEFAULT_RTP = void 0;
const constants_1 = require("../constants");
exports.DEFAULT_RTP = -1;
exports.DEFAULT_SRP = -1;
exports.DEFAULT_FREQUENCY = -1;
exports.DEFAULT_PERCENTAGE = -1;
/**
 * @param {number} win
 * @param {number} bet
 * @returns {number}
 */
function getRTP(win, bet) {
    return (bet
        ? win / bet * constants_1.HUNDRED_PERCENT
        : exports.DEFAULT_RTP);
}
exports.getRTP = getRTP;
function getSRP(sumRTP, totalSpins) {
    return (totalSpins
        ? sumRTP / totalSpins
        : exports.DEFAULT_SRP);
}
exports.getSRP = getSRP;
function getPL(bet, win) {
    return win - bet;
}
exports.getPL = getPL;
function getFrequency(a, b) {
    return (b
        ? a / b
        : exports.DEFAULT_FREQUENCY);
}
exports.getFrequency = getFrequency;
function getPercentage(a, b) {
    return (b
        ? a / b * constants_1.HUNDRED_PERCENT
        : exports.DEFAULT_PERCENTAGE);
}
exports.getPercentage = getPercentage;
function getStandardDeviation(sum, sumOfSquares, count) {
    if (!count) {
        return 0;
    }
    const square = 2;
    return Math.sqrt((sumOfSquares / count) - (Math.pow((sum / count), square)));
}
exports.getStandardDeviation = getStandardDeviation;
